module.exports = __webpack_public_path__ + "img/IMAGE7.b4e337cc.jpeg";